import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_afmsxhpte4: FaireBrandEntity = {
  token: "b_afmsxhpte4",
  type: "brand",
  name: "Thirteenwinks",
  avatarUrl:
    "https://cdn.faire.com/fastly/c1cb76a942204b4570c5f310ba1fc17755c565949a038c9adc805f4f80ebbdc2.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/3546253700524b51432930cc164584c97cfca227fe44e18450167aab5d4b07d3.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/c1cb76a942204b4570c5f310ba1fc17755c565949a038c9adc805f4f80ebbdc2.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/3546253700524b51432930cc164584c97cfca227fe44e18450167aab5d4b07d3.jpeg",
  location: "Virginia Beach, VA, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 54,
  isInsider: true,
  description:
    'At Thirteenwinks we focus on creating an "elevated souvenir" the perfect gift to give or buy for yourself! These stickers, paper goods and acrylic keepsakes focus on fun color with a bit of hand lettering and southern charm thrown in. Our designs are all about the details that remind you of your hometown, college town, or favorite spot! Each design is researched and hand drawn by Carla Ryan our founder to create a one of a kind collage of local elements.\n\n',
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:51:19.900Z",
    importedBy: "entity-db-cli",
  },
};
